import gql from 'graphql-tag'

export const trackersQuery = gql`
  query trackersQuery($userId: ID!, $isPublic: Boolean, $isAdmin: Boolean) {
    allTrackers(
      filter: {
        OR: [
          { user: { id: $userId } }
          { AND: [{ isPublic: $isPublic }, { isAdmin: $isAdmin }] }
        ]
      }
    ) {
      id
      name
      category
      isStared
      isDuration
      color
      isPublic
      type
    }
  }
`

export const trackerTasksQuery = gql`
  query trackerTasksQuery($id: ID!) {
    Tracker(id: $id) {
      currentId
      currentName
      tasks {
        id
        name
        currentId
        currentName
        subtask {
          id
          name
        }
      }
    }
  }
`

export const adminTrackers = gql`
  query adminTrackers($isPublic: Boolean, $isAdmin: Boolean) {
    allTrackers(
      filter: { AND: [{ isPublic: $isPublic }, { isAdmin: $isAdmin }] }
    ) {
      id
      name
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/tracker.js